// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/rate/style/index.less
// module id = 1429
// module chunks = 0